import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import Vue from 'vue';
import store from '@/store';
import authModule from '@/store/modules/auth';
import catalogModule from '@/store/modules/catalog';
import { getModule } from 'vuex-module-decorators';
import titleCase from '@/utils/filters/titleCase';
import { type DomainUiLightDto } from '@/api';
import Constants from '@/utils/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'Domain-Selector',
  setup(__props) {
const auth = getModule(authModule, store);
const catalog = getModule(catalogModule, store);

const selectedDomain = _computed(() => auth.getDomain);
const items = _computed(() => auth.getUserDomains);

const setDomain = (domain: DomainUiLightDto) => {
  auth.setDomain(domain);
  Vue.nextTick(() => {
    catalog.fetchData();
  });
};

return { __sfc: true,auth, catalog, selectedDomain, items, setDomain, _computed, Vue, store, authModule, catalogModule, getModule, titleCase, Constants }
}

})